import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Building2, MapPin } from 'lucide-react';
import api from '@/lib/api';
import MapPicker from '@/components/ui/MapPicker';

export default function CreateGym() {
    const [form, setForm] = useState({ name: '', address: '', phone: '', email: '', lat: '', lng: '' });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError('');
        const payload = {
            ...form,
            lat: form.lat ? parseFloat(form.lat) : undefined,
            lng: form.lng ? parseFloat(form.lng) : undefined,
        };
        try {
            await api.post('/owner/gyms', payload);
            window.location.href = '/panel/suscripciones';
        } catch (err) {
            setError(err.response?.data?.message || 'Error al crear el gimnasio.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-black p-4">
            <Card className="w-full max-w-md bg-[#0a0a0a] border-[#3a3a3f]">
                <CardHeader className="text-center">
                    <div className="mx-auto h-12 w-12 bg-white/10 rounded-full flex items-center justify-center mb-3">
                        <Building2 className="h-6 w-6 text-white" />
                    </div>
                    <CardTitle className="text-white uppercase tracking-wide text-xl">Creá tu Gimnasio</CardTitle>
                    <CardDescription className="text-white/60">
                        Antes de empezar, necesitás crear un gimnasio para gestionar tus alumnos.
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        {error && (
                            <div className="bg-white/5 border border-[#3a3a3f] text-white text-sm p-3 rounded-md">{error}</div>
                        )}
                        <div className="space-y-2">
                            <Label className="text-white/60 uppercase tracking-wider text-xs">Nombre del gimnasio</Label>
                            <Input
                                value={form.name}
                                onChange={e => setForm({ ...form, name: e.target.value })}
                                required
                                placeholder="Ej: FitZone Gym"
                                className="bg-[#0a0a0a] border-[#3a3a3f] text-white placeholder:text-white/30 focus-visible:ring-white"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label className="text-white/60 uppercase tracking-wider text-xs">Dirección</Label>
                            <Input
                                value={form.address}
                                onChange={e => setForm({ ...form, address: e.target.value })}
                                placeholder="Ej: Av. Corrientes 1234"
                                className="bg-[#0a0a0a] border-[#3a3a3f] text-white placeholder:text-white/30 focus-visible:ring-white"
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <Label className="text-white/60 uppercase tracking-wider text-xs">Teléfono</Label>
                                <Input
                                    value={form.phone}
                                    onChange={e => setForm({ ...form, phone: e.target.value })}
                                    placeholder="1144005678"
                                    className="bg-[#0a0a0a] border-[#3a3a3f] text-white placeholder:text-white/30 focus-visible:ring-white"
                                />
                            </div>
                            <div className="space-y-2">
                                <Label className="text-white/60 uppercase tracking-wider text-xs">Email</Label>
                                <Input
                                    type="email"
                                    value={form.email}
                                    onChange={e => setForm({ ...form, email: e.target.value })}
                                    placeholder="info@gimnasio.com"
                                    className="bg-[#0a0a0a] border-[#3a3a3f] text-white placeholder:text-white/30 focus-visible:ring-white"
                                />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <Label className="text-white/60 uppercase tracking-wider text-xs flex items-center gap-1">
                                <MapPin className="h-3 w-3" />Ubicación en el mapa
                            </Label>
                            <MapPicker
                                onChange={({ lat, lng }) => setForm({ ...form, lat: String(lat), lng: String(lng) })}
                            />
                        </div>
                        <Button type="submit" disabled={saving} className="w-full">
                            {saving ? 'Creando...' : 'Crear Gimnasio'}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}
